// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m7-1";
export var messageSideRight = "_m7-2";
export var subscribeToBackInStockBubbleContainer = "_m7-0";